export default {
  data() {
    return {
      themeClass: this.$route.query.theme || ''
    }
  }
}
